<template>
  <div id="" style="position: relative">

  <v-row no-gutters>

    <v-col class="flex-nogrow" :cols="isMobile? 0 : 2">
      <v-navigation-drawer
      v-model="drawer"
      width="auto"
      :permanent="!isMobile"
      :absolute="isMobile"
      :right="isMobile"
       :class="{'fill-height-screen':!isMobile}">
        <v-list dense shaped style="overflow-y:auto">
          <v-list-item-group v-model="modelSelected" color="secondary" mandatory>
            <template v-for="model in models">
              <v-list-item
              :value="model"
              :key="model.name"
              @click="selectModel(model)"
              v-if="model.ability === undefined || hasPermission(model.ability)"
              link >
              <v-list-item-content>
                <v-list-item-title>{{ model.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-col>

    <v-col :cols="isMobile ? 12 : 10">
      <model-table-editor class="fill-height-screen" v-if="modelSelected" :model="modelSelected">
        <template slot="buttons">

          <v-btn icon color="white" @click="downloadSetup()" :loading="loadingDownload" class="hidden-xs">
            <v-icon>cloud_download</v-icon>
          </v-btn>

          <v-btn icon color="white" @click="$refs.inputUpload.click()" :loading="loadingUpload" class="hidden-xs">
            <v-icon>cloud_upload</v-icon>
          </v-btn>
          <input v-show="false" ref="inputUpload" type="file" @change="uploadSetup()" >
          <v-btn icon color="white" v-show="isMobile" @click="toggleDrawer()" class="mr-2">
            <v-icon>menu</v-icon>
          </v-btn>
        </template>
      </model-table-editor>
    </v-col>
  </v-row>




</div>
</template>
<script>

import modelTableEditor from "@/components/modelTableEditorNative";
import Repository from "@/models/repoIrricrops";
import _ from 'lodash';

export default {
  name: "crud",
  components: {
    modelTableEditor
  },
  data: () => ({
    modelSelected   : null,
    drawer          : false,
    loadingUpload   : false,
    loadingDownload : false,
    models          : [
      {name : "usuarios",       model : "userModel", ability:"config_editar_admin"},
      {name : "empresas",       model : "empresaModel", ability:"config_editar_admin"},
      //{name : "rol",            model : "rolModel"},
      //{name : "abilities",      model : "abilityModel"},
      {name : "contratistas",   model : "contratistaModel"},
      {name : "trabajadores",   model : "trabajadorModel"},
      {name : "campos",         model : "campoModel"},
      {name : "especies",       model : "especieModel"},
      {name : "variedades",     model : "variedadModel"},
      {name : "cuarteles",      model : "cuartelModel"},
      {name : "centros costo",  model : "centrosCostoModel"},
      {name : "contrato",       model : "contratoModel"},
      {name : "tipo Contrato",  model : "tipoContratoModel"},
      {name : "Familia Labores",model : "laborModel"},
      {name : "unidades",       model : "unidadModel"},
      {name : "Labores",        model : "subLaborModel"},
      //{name : "asistencias",    model : "asistenciaModel"},
      //{name : "tarjas",         model : "tarjaModel"},
    ]
  }),
  watch: {
    $route() {
      if(this.$route.params.name){
        var item = _.find(this.models, {name: this.$route.params.name});
        if(item){
          this.selectModel(item, false);
        }
      }
    }
  },
  computed:{
    abilities() {
      return this.$store.getters.abilities;
    },
    isMobile(){
      return this.$store.getters.isMobile;
    },
    queryString(){
      return this.$route.query;
    },
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
  },
  created(){
    this.modelSelected = _.first(this.models);
    if(this.$route.params.name){
      var item = _.find(this.models, {name: this.$route.params.name});
      if(item){
        this.selectModel(item, false);
      }
    }
  },
  methods: {
    toggleDrawer(){
      //this._routerRoot.$emit('toggleDrawer');
      this.drawer = !this.drawer;
    },
    selectModel(model, changeRoute = true){
      this.modelSelected = model;
      this.drawer = false;
      if(changeRoute){
        this.$router.push({path: "/crud/"+model.name, query: this.queryString});
      }
    },
    hasPermission(ability){
      return ability ? _.find(this.abilities, {name: ability} ) : true;
    },


    //https://codepen.io/nigamshirish/pen/ZMpvRa
    downloadSetup(){
      this.loadingDownload = true;
      Repository.get('/export/set-up/'+this.empresaSelected.id,{
        params:{
          //empresa_id: this.empresaSelected.id,
        },
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.loadingDownload = false;
        this.forceFileDownload(response)
      },function(resError){
        this.loadingUpload = false;
        this.$store.commit("showSnackBar", resError.message);
        console.log('FAILURE!!');
      })
      .catch(() => console.log('error occured'))
    },
    forceFileDownload(response){
      const url  = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href  = url
      link.setAttribute('download', this.empresaSelected.nombre + '.xlsx')
      document.body.appendChild(link)
      link.click()
    },
    //https://serversideup.net/uploading-files-vuejs-axios/
    uploadSetup(){
      this.loadingUpload = true;
      this.file = this.$refs.inputUpload.files[0];
      var self = this;
      /*
      Initialize the form data
      */
      let formData = new FormData();

      /*
      Add the form data we need to submit
      */
      formData.append('archivo', this.file);

      /*
      Make the request to the POST /single-file URL
      */
      Repository.post( '/import/set-up',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        params:{
          empresa_id: this.empresaSelected.id,
        },
      }
    ).then(function(res){
      self.loadingUpload = false;
      self.$refs.inputUpload.value = ''
      self.$store.commit("showSnackBar", res.data);
      console.log('SUCCESS!!');
    },function(resError){
      self.loadingUpload = false;
      self.$refs.inputUpload.value = ''
      self.$store.commit("showSnackBar", resError.message);
      console.log('FAILURE!!');
    });
  }
  }
}
</script>
<style lang="scss" scoped>
</style>
